import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '@core/react-query/features/analytics/requestTypes'
import { analyticsKeys } from '@core/react-query/features/analytics'
import { AnalyticsDashboardList } from '@core/entities/analytics'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useGetAnalyticsDashboardList = (
  payload: RequestTypes['getAnalyticsDashboardList'],
  options?: UseQueryOptions<AnalyticsDashboardList, RequestErrorType>,
) => {
  return useQuery({
    ...analyticsKeys.getAnalyticsDashboardList(payload),
    ...options,
  })
}
